<article
  class="promo"
  [ngClass]="background()"
  [class.rtl]="rtl()"
  [appStoryblok]="_editable()"
  aria-labelledby="promo-title"
>
  <div class="promo-content">
    <h1 id="promo-title" class="ui-heading-1">{{ title() }}</h1>
    <h2 class="ui-heading-2">{{ subtitle() }}</h2>

    @if(components) { @for (paragraph of description(); track paragraph._uid) {
    <p class="ui-body-l">{{ paragraph.content }}</p>
    }

    <div class="buttons">
      @for(btn of buttons(); track btn._uid){ @if (components[btn.component]) {
      <ndc-dynamic
        [ndcDynamicComponent]="components[btn.component]"
        [ndcDynamicInputs]="btn"
      >
      </ndc-dynamic>
      } @else {
      <ndc-dynamic
        [ndcDynamicComponent]="components['notImplemented']"
        [ndcDynamicInputs]="btn"
      >
      </ndc-dynamic>
      } }
    </div>

    <div class="links">
      @for(item of links(); track item._uid){
      <button
        rds-link
        standalone
        (click)="navigate(item.isExternal, item.link)"
        (keydown.enter)="navigate(item.isExternal, item.link)"
      >
        {{ item.title }}
        <rds-icon namespace="filled" icon="arrow_right" />
      </button>
      }
    </div>
    }
  </div>

  @if(image()?.filename) {
  <figure class="promo-image" [style.width.%]="imageWidthPercentage()">
    <inexp-image [image]="image()"></inexp-image>
  </figure>
  }
</article>
